export const renderRoleName = (role: Oneflow.Role) => (
  <>
    <p>{role?.name}</p>
  </>
);

export const renderPermissionCount = (role: Oneflow.Role) => `${role?.permissionCount}/${role?.maxPermissionCount}`;
